import { unauthorizedApiInstance } from './index';

const AppApi = {
    getVersion: (params) => unauthorizedApiInstance.get('app/version', params)
};

export default AppApi;
